import React from "react"
import PropTypes from "prop-types"

import { ingredientShape } from "app/lib/shared_prop_types"

export default function ApiList({ contextData, platform }) {
  const apiList = generateApiList(contextData)

  if (apiList.length) {
    return (
      <div className={`${platform ? "platform" : "diy"}-filter-code-api-list`}>
        {apiList.map(({ name, items }) => (
          <div key={name}>
            <h4>{name}</h4>
            <ul>
              {items.map(item => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    )
  } else {
    return null
  }
}

ApiList.propTypes = {
  platform: PropTypes.bool,
  contextData: PropTypes.shape({
    services: PropTypes.array,
    trigger: PropTypes.shape({
      ingredients: PropTypes.arrayOf(ingredientShape),
    }),
  }).isRequired,
}

function generateApiList(contextData) {
  const apiList = []
  const { services, trigger } = contextData
  const triggerService = services.find(s => s.trigger)
  const queryServices = services.filter(s => s.queries.length)
  const actionServices = services.filter(s => s.actions.length)

  if (trigger && triggerService)
    apiList.push(buildTriggerDefinitions(triggerService, trigger))
  if (queryServices.length) apiList.push(buildQueryDefinitions(queryServices))
  if (actionServices.length)
    apiList.push(buildActionDefinitions(actionServices))

  apiList.push(buildMetaDefinitions())

  return apiList
}

function buildTriggerDefinitions(triggerService, trigger) {
  return {
    name: "Trigger data",
    items: buildIngredientsAPIList(
      objectName(triggerService, trigger),
      trigger.ingredients
    ),
  }
}

function buildQueryDefinitions(queryServices) {
  return {
    name: "First query results",
    items: buildQueryAPIList(queryServices),
  }
}

function buildActionDefinitions(actionServices) {
  return {
    name: "Actions",
    items: buildActionAPIList(actionServices),
  }
}

function buildMetaDefinitions() {
  return {
    name: "Other",
    items: ["Meta.currentUserTime", "Meta.triggerTime"],
  }
}

function buildQueryAPIList(queryServices) {
  const definitions = []
  queryServices.forEach(service =>
    service.queries.forEach(query => {
      const firstObjectName = `${objectName(service, query)}[0]`
      buildIngredientsAPIList(firstObjectName, query.ingredients).forEach(def =>
        definitions.push(def)
      )
    })
  )
  return definitions
}

function buildIngredientsAPIList(objectName, ingredients) {
  return ingredients.map(i => `${objectName}.${i.name}`)
}

function buildActionAPIList(actionServices) {
  const definitions = []
  actionServices.forEach(service =>
    service.actions.forEach(action => {
      const actionObjectName = objectName(service, action)
      definitions.push(`${actionObjectName}.skip()`)
      buildFieldsAPIList(actionObjectName, action.fields).forEach(def =>
        definitions.push(def)
      )
    })
  )
  return definitions
}

function buildFieldsAPIList(objectName, stepFields) {
  return stepFields.map(f => `${objectName}.set${f.name}()`)
}

function objectName(service, step) {
  return `${service.name}.${step.name}`
}
